module.exports = __webpack_public_path__ + "img/faq.c7763be6.png";